var _circle, _circle2, _circle3, _circle4, _g, _circle5, _circle6, _circle7, _circle8, _g2, _circle9, _circle0, _circle1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 47,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24.864,
  cy: 25.091,
  r: 11.636,
  fill: "#F2A178"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.864,
  cy: 23.636,
  r: 11.454,
  fill: "url(#Coin_svg__a)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.864,
  cy: 23.636,
  r: 11.454,
  fill: "url(#Coin_svg__b)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.864,
  cy: 23.636,
  r: 11.454,
  stroke: "#F4C357",
  strokeWidth: 0.364
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Coin_svg__c)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24.136,
  cy: 23.636,
  r: 11.636,
  fill: "url(#Coin_svg__d)"
}))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.864,
  cy: 23.636,
  r: 9.455,
  fill: "#FDEF65"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.864,
  cy: 23.636,
  r: 9.455,
  fill: "url(#Coin_svg__e)"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.864,
  cy: 23.636,
  r: 9.455,
  fill: "url(#Coin_svg__f)",
  fillOpacity: 0.5
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.864,
  cy: 23.636,
  r: 9.273,
  stroke: "#EC8332",
  strokeOpacity: 0.2,
  strokeWidth: 0.364
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Coin_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#Coin_svg__h)",
  d: "M25.654 28.99a4.6 4.6 0 0 1-1.809-.348 4.1 4.1 0 0 1-1.403-1.027q-.578-.665-.896-1.634-.32-.97-.319-2.213 0-1.23.319-2.199.318-.983.896-1.649a3.9 3.9 0 0 1 1.403-1.013 4.45 4.45 0 0 1 1.809-.361q.723 0 1.244.159.535.145.925.39.39.232.666.55.263.289.477.578a.07.07 0 0 1-.016.101L27.5 21.377a.074.074 0 0 1-.107-.023q-.304-.51-.697-.769-.405-.288-1.041-.289-.695 0-1.244.449-.535.448-.753 1.23h3.255c.04 0 .072.032.072.072v1.156c0 .04-.032.073-.072.073h-3.37v.983h3.37c.04 0 .072.033.072.073v1.157c0 .04-.032.072-.072.072h-3.255q.203.825.738 1.259.535.42 1.259.42 1.193 0 1.882-1.16a.074.074 0 0 1 .107-.022l1.456 1.068a.07.07 0 0 1 .017.098 5 5 0 0 1-.483.608 3.2 3.2 0 0 1-.723.579q-.42.26-.984.42-.549.158-1.272.159"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Coin_svg__i)",
  style: {
    mixBlendMode: "overlay"
  }
}, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.682,
  cy: 17.091,
  r: 2.182,
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Coin_svg__j)",
  style: {
    mixBlendMode: "overlay"
  }
}, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.409,
  cy: 14.182,
  r: 0.727,
  fill: "#FBC02D"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Coin_svg__k)",
  style: {
    mixBlendMode: "overlay"
  }
}, _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.682,
  cy: 35.636,
  r: 0.364,
  fill: "#FBC02D"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Coin_svg__c",
  width: 46.545,
  height: 46.545,
  x: 0.864,
  y: 0.364,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 5.818
})), /*#__PURE__*/React.createElement("filter", {
  id: "Coin_svg__g",
  width: 7.901,
  height: 13.353,
  x: 21.227,
  y: 18.546,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.909
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.455
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.921569 0 0 0 0 0.521569 0 0 0 0 0.235294 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Coin_svg__i",
  width: 10.182,
  height: 10.182,
  x: 25.591,
  y: 12,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 1.455
})), /*#__PURE__*/React.createElement("filter", {
  id: "Coin_svg__j",
  width: 2.909,
  height: 2.909,
  x: 13.954,
  y: 12.728,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 0.364
})), /*#__PURE__*/React.createElement("filter", {
  id: "Coin_svg__k",
  width: 2.182,
  height: 2.182,
  x: 33.591,
  y: 34.545,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 0.364
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Coin_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(90 5.886 18.977)scale(17.8182)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFE89"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F6DD54"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Coin_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(33.179 -27.238 53.548)scale(11.2962)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFCB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.322,
  stopColor: "#FFFA6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.717,
  stopColor: "#F9D858"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4AC41"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Coin_svg__f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(79.046 -1.882 24.655)scale(11.4819)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Coin_svg__a",
  x1: 24.864,
  x2: 24.864,
  y1: 12,
  y2: 35.273,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFE91"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5DC50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Coin_svg__d",
  x1: 24.136,
  x2: 24.136,
  y1: 12,
  y2: 35.273,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFE91"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5DC50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Coin_svg__h",
  x1: 28.189,
  x2: 22.764,
  y1: 19.323,
  y2: 27.46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E47437"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1A53D"
})))));
export { SvgCoin as ReactComponent };
export default __webpack_public_path__ + "Coin.6e116c89.svg";